<template>
    <aurora-layout>
        <div class="steps my-10">
            <div class="steps-title flex justify-around w-350 md:w-670 mx-auto">
                <p class="text-white">Consent form</p>
                <p class="text-white mr-5">Bank account</p>
            </div>
            <div class="step-progress flex justify-around my-5">
                <AuroraStepProgress :step="1" />
            </div>
            <div class="box-content-container">
                <AppBoxContent>
                    <h2 class="text-center text-2xl md:text-4xl">
                        {{ user.first_name }}, you are almost done.
                    </h2>
                    <p class="text-center my-5">You are almost done.</p>

                    <div class="info-box-container my-14 sm:p-0 md:px-16 lg:px-28">
                        <AuroraListInfo label="Name" :value="user.full_name" />

                        <!-- Hide Amount field for leadgen users -->
                        <AuroraListInfo label="Amount" v-if="false">
                            <select
                                v-model="selectedAmount"
                                name="" 
                                id="" 
                                class="amount-select rounded w-full text-[#000] focus:outline-none border border-gray-200 appearance-none bg-transparent max-w-32 pl-4">
                                <option 
                                    v-for="(amount, key) in getDefaultAmounts" 
                                    :value="key" 
                                    :key="key">
                                    {{ amount | money(0) }}
                                </option>
                            </select>
                        </AuroraListInfo>   
                        <AuroraListInfo label="Email" :value="user.email" />

                        <!-- Consents Section -->
                        <div class="consents-section mt-10">
                            <ConsentsCheckBoxes 
                                ref="consentsComponent"
                                @validation-changed="onValidationChanged"
                            />
                        </div>
                    </div>

                    

                    <div class="button-container flex align-center justify-center sm:mt-16">
                        <AppButton
                            data-testid="continue"
                            :loading="loading"
                            :btn-style="'solid'"
                            @click="handleClickNextStep()"
                        >
                            Continue
                        </AppButton>
                    </div>
                </AppBoxContent>

            </div>
        </div>
    </aurora-layout>
</template>

<script>
import AuroraStepProgress from "../../../components/AuroraStepProgress";
import AppBoxContent from "./../../../../../components/AppBoxContent";
import AuroraListInfo from "../../../components/AuroraListInfo";
import AppButton from "./../../../../../components/AppButton";
import ConsentsCheckBoxes from "./../../../../../components/ConsentsCheckBoxes";

export default {
    mixins: [
        require("../../../../../mixins/InteractsWithGtag").default,
        require("../../../../../mixins/WelcomeMethods").default,
        require("../../../../../mixins/AddTagToLoan").default,
        require("../../../../../mixins/GetLoansAmountsByState").default,
        require("../../../../../mixins/TrackAmountChanges").default,
        require("../../../../../mixins/PageViewAnalytics").default,
    ],

    components: {
        AuroraStepProgress,
        AppBoxContent,
        AuroraListInfo,
        AppButton,
        ConsentsCheckBoxes,
    },

    props: {
        user: {},
        loan: {},
    },

    data() {
        return {
            loading: false,
            adult_check: true,
            bankruptcy_check: true,
            gTagPageName: "AUTHORIZE_LENDER_LEADGEN",
            selectedAmount: "",
            originalAmount: "",
            allRequiredChecked: false, // Track validation state
        };
    },

    mounted() {
        this.selectedAmount = this.originalAmount = this.loan.amount;
    },

    methods: {

        handleClickNextStep() {
            if (this.allRequiredChecked) {
                this.loading = true;

                // Get consent data from child component
                const consentsData = this.$refs.consentsComponent.getConsentsData();
                
                this.accept(consentsData);
            } else {
                // Show validation error message in consents component
                this.$refs.consentsComponent.showError();
            }
        },
        onValidationChanged(isValid) {
            this.allRequiredChecked = isValid;
        },

        disabledButton() {
            return this.allRequiredChecked === false;
        },
    },
};
</script>
